import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var l=e=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",height:"1em",viewBox:"0 0 512 512",fill:"currentColor"},e),{children:jsx("path",{d:"M83.4 226.6L304 256 83.4 285.4 0 480H64L512 256 64 32H0L83.4 226.6z"})})),n=l;

export { n as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-3PRQOOUH.mjs.map